function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import cn from 'classnames';
import { getImageWithParams } from 'swag-client-common/utils/tricks';
import classes from './product-previews.scss';
class ProductPreviews extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderPreview", (image, idx) => {
      const {
        view,
        onChangeView
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: cn(classes.wrapper, {
          [classes.active]: image.id === view
        }),
        onClick: () => onChangeView(image.id)
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.inner
      }, /*#__PURE__*/React.createElement("img", {
        className: classes.productImage,
        src: getImageWithParams({
          url: image.url,
          height: 90
        })
      })));
    });
  }
  render() {
    const {
      images
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.row
    }, images.map((image, idx) => image.url && this.renderPreview(image, idx))));
  }
}
export default ProductPreviews;